import partneringOne from './partneringOne'
import partneringOnePlus from './partneringOnePlus'

const apiClient = {
  partneringOne,
  partneringOnePlus,
}

export default apiClient
